// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3JJ7d","modalFooterButton":"ModalNotes_modalFooterButton__F1Nrc"};